// extracted by mini-css-extract-plugin
export default {"backButton":"_2cqoadduFuKFSlnaOnVWyQ=="};